import {
  type IPackageCardProps,
  PackageCard,
} from 'pages/settings/pages/compliance/pages/localNumbers/pages/Package/ui/PackageCard/PackageCard.tsx'
import { packageTooltipDesc } from './data.tsx'

export const StandardPackageCard = (props: Partial<IPackageCardProps>) => {
  return (
    <PackageCard
      title={'Standard'}
      titleLabel={'Recommended'}
      titleSub={'82% of companies your size use the "Standard" package'}
      infoOne={{
        title: 'up to 600,000 SMS / MMS segments per day',
        tooltip: packageTooltipDesc,
      }}
      infoTwo={{
        title: 'up to 225 MPS',
        tooltip: 'Messages per second',
      }}
      {...props}
    />
  )
}
